import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

const CHECK_ANSWER_MUTATION = mutation({
  checkAnswer: [
    { input: input('input', 'CheckAnswerInput!') },
    {
      isCorrect: true,
    },
  ],
});

type CheckAnswerInputType = VariablesOf<typeof CHECK_ANSWER_MUTATION>['input'];
type CheckAnswerResponseType = ResultOf<typeof CHECK_ANSWER_MUTATION>['checkAnswer'];

export const checkAnswerMutationRequest = async (
  props: CheckAnswerInputType
): Promise<ResultType<CheckAnswerResponseType>> => {
  const client = getReadingCrittersClientUtil();

  const response = await client.mutation(CHECK_ANSWER_MUTATION, { input: props }, { useAuth: true });

  return {
    success: Boolean(response?.checkAnswer),
    data: response?.checkAnswer ?? { isCorrect: false },
  };
};
